import { render, staticRenderFns } from "./MotivosBloqueio.vue?vue&type=template&id=7756e13f"
import script from "./MotivosBloqueio.vue?vue&type=script&lang=js"
export * from "./MotivosBloqueio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports